import axios from "axios";
const api = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "/api",
   withCredentials: true,
});
export default api;
